import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_MEMBER_IN_MANDATE_PAGINATION } from "../Schema/Member";

export const useGetMemberInMandatePagination = ({ partyId, isActive }) => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState("");
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [paginationData, setPaginationData] = useState({});

  const { refetch } = useQuery(GET_MEMBER_IN_MANDATE_PAGINATION, {
    variables: {
      page: page,
      limit: limit,
      keyword: keyword,
      partyId: partyId,
      pagination: true,
      isActive,
    },
    onCompleted: ({ getMemberInMandatePagination }) => {

      setTableData(getMemberInMandatePagination?.data);
      setPaginationData(getMemberInMandatePagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err);
    },
  });

  const handleSearch = (e) => {
    setPage(1);
    setKeyword(e.target.value);
  };

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  useEffect(() => {
    refetch();
  }, [page, limit, keyword]);

  return {
    page,
    limit,
    setPage,
    refetch,
    loading,
    tableData,
    setLoading,
    handleLimit,
    handleSearch,
    paginationData,
  };
};
